/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Open_TextInputs */

const en_gc_story_open_text = /** @type {(inputs: Gc_Story_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with a copy of a small Excel workbook. In the GridCraft online editor, use the file-open control to select an XLSX file from your computer. Inspect the sheet names, column widths, number formats and a few formulas before making changes. XLSX is GridCraft’s native format, but an alpha application can interpret complex files differently. For everyday experiments, a short expense sheet is a better first test than a business-critical financial model. When you finish, use Save As to download an XLSX copy and reopen it to check your work.`)
};

const zh_gc_story_open_text = /** @type {(inputs: Gc_Story_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从一份较小 Excel 工作簿的副本开始。在 GridCraft 在线编辑器中选择打开文件，导入电脑上的 XLSX。修改前先检查工作表名称、列宽、数字格式和几处公式。XLSX 是原生格式，但 Alpha 应用可能对复杂文件有不同处理。初次体验建议使用简短的支出表，结束后通过另存为下载 XLSX 副本，再重新打开检查。`)
};

/**
* | output |
* | --- |
* | "Start with a copy of a small Excel workbook. In the GridCraft online editor, use the file-open control to select an XLSX file from your computer. Inspect the..." |
*
* @param {Gc_Story_Open_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_open_text = /** @type {((inputs?: Gc_Story_Open_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Open_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_open_text(inputs)
	return zh_gc_story_open_text(inputs)
});
export { gc_story_open_text as "gc.story.open.text" }